// Meta (Facebook) Pixel — tracking helpers.
// The base pixel is loaded from /public/index.html.
// These helpers are safe to call before fbq is ready (queued via fbq.queue).

/**
 * Fire a Meta Pixel Standard Event.
 * @param {string} event - Standard event name (e.g. "Lead", "Contact", "Schedule").
 * @param {object} [params] - Custom parameters (source, value, currency, content_name, etc.)
 */
export const track = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      if (params && Object.keys(params).length > 0) {
        window.fbq("track", event, params);
      } else {
        window.fbq("track", event);
      }
    }
  } catch {
    /* noop — never let analytics break UX */
  }
};

/**
 * Attach a document-level capture listener that auto-tracks Contact events for
 * every tel: and WhatsApp link click across the site — no per-component edits needed.
 * Idempotent: safe to call multiple times; only wires once.
 */
let clickListenerAttached = false;
export const initClickTracking = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (clickListenerAttached) return;
  clickListenerAttached = true;

  document.addEventListener(
    "click",
    (e) => {
      const a =
        (e.target && e.target.closest && e.target.closest("a")) || null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const source = window.location.pathname || "unknown";
      if (href.startsWith("tel:")) {
        track("Contact", { channel: "phone", source });
      } else if (
        href.includes("wa.me") ||
        href.includes("api.whatsapp.com") ||
        href.includes("web.whatsapp.com")
      ) {
        track("Contact", { channel: "whatsapp", source });
      }
    },
    { capture: true }
  );
};
